import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import KTnetModal2 from '../../../module/ktnet/KTnetModal2'
import KTnetModalExport from '../../../module/ktnet/KTnetModalExport'
import KTnetModalImport from '../../../module/ktnet/KTnetModalImport'
import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import { valid } from '../../../hook/valid'

const CrtfctStepMobile01 = (props) => {
  const [state, setState] = useState({
    isView: false,
    regNo1: '',
    regNo2: '',
    checkedRegNo: false, //주민번호 정상체크
    regNo: '',
    certCode: '',
    rtnCode: '',
    password: '',
    crtfctSuccess: false,
  })
  let strCode='';
  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })

  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    jtCrtfctId: '',
    jtCrtfctDn: '',
    bgngYmd: '',
    endYmd: '',
  })

  const handleChange = (e) => {
    const { value, name } = e.target // 우선 e.target 에서 name 과 value 를 추출
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    })
  }

  /**
   * 인증서 툴킷 띄우기 전에 번호 확인
   * @param regNo1
   * @param regNo2
   * @returns
   */
  const toolkitCheckRegNo = (regNo1, regNo2) => {
    /*   setState({
        ...state,
        regNo: state.regNo1 + state.regNo2 
      }) */
    if (!regNo1) {
      return props.error({ message: '주민번호 앞자리를 입력해주세요.' })
    }
    if (!regNo2) {
      return props.error({ message: '주민번호 뒷자리를 입력해주세요.' })
    }

    let checkResult = valid.isValidJuminNo(regNo1, regNo2)
    if (!checkResult) {
      return props.error({ message: '정상적인 주민등록 번호가 아닙니다.' })
    }

    props.checkedRegNo(checkResult)
  }
  const checkStepTrue = () => {
    localStorage.setItem('isSave', true)
  }
  const checkStepFalse = () => {
    localStorage.setItem('isSave', false)
  }
  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    //console.log(localStorage.getItem('isSave'));
    if (localStorage.getItem('isSave') === 'true') {
      props.onCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    } else {
      props.delCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    }
  }

  /*   const getCrtfctNumber = () => {
    window.location.href = '/CrtfctStepMobile01'
  } */

  /**
   * 1-1
   * 인증서 인증코드 가져오기
   */
  useEffect(() => {
    window.M.execute(
      'exWNGetCertCode',
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(JSON.stringify(result))
          //setState({...state, certCode: result.data.certCode})
          //strCode = JSON.stringify(result.data.certCode)
          //console.log(strCode)
          //console.log(typeof strCode)
          //rtnCode = result.data.rtnCode
          const obj = {
            certCode: result.data.certCode,
            rtnCode: result.data.rtnCode,
          }
          setState({ ...state, ...obj })
          // setState({...state, rtnCode: result.data.rtnCode})
          //window.M.pop.alert('certCode : ' + obj.certCode + ', rtnCode : ' + obj.rtnCode);
        })
        .toString(),
    )
  }, [])

  /**
   * 1-2
   * 인증서 가져오기
   */    
    function getCrtfctConfirm(){
      //console.log(state.certCode.toString.substr(0,4) + "-"+ state.certCode.toString.substr(5,8)+ "-"+ state.certCode.toString.substr(9,13))
      window.M.execute('exWNGetCert', state.certCode, state.rtnCode,
	    window.M.response.on( function( status, result ) {
            console.log(status);
            console.log(JSON.stringify(result));
            //window.M.pop.alert('1-2 status : ' + status + ', result : ' + JSON.stringify(result) + 'certCode : ' + state.certCode + ', rtnCode : ' + state.rtnCode);
            if(status === 'SUCCESS'){
              setState({...state, crtfctSuccess: true})
            }
        }).toString()
      );   
    }
    /**
    * 1-3
    * 인증서 비밀번호 검증 후 다운로드
    */    
    function getCrtfctDownLoad(){
        var pfx = '';
        window.M.execute('exWNChkPassword', state.password, state.certCode, pfx,
            window.M.response.on( function( status, result ) {
                console.log(status);
                console.log(JSON.stringify(result));
               // window.M.pop.alert('1-3 status : ' + status + ', result : ' + JSON.stringify(result)+ ', pass:'+ state.password);
                if(status === 'SUCCESS'){
                  crtfctDowncomplete()
                }
            }).toString()
        );
    }

  /**
   * 네이티브 화면 메시지 처리
   */
  const crtfctDowncomplete = () => {
    props.success({
      title: '확인',
      message: '인증서 다운로드를 완료했습니다.',
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.href = '/crtfct/mngMobile'
        },
      },
    })
  }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <React.Fragment>
      {/* <!-- contents --> */}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={prePage}>
            뒤로이동
          </a>
          {/* <!-- mobile --> */}
          <h2>공동인증서 관리</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>마이페이지</span>
            <em>공동인증서 가져오기</em>
          </div>
        </div>

        <div className="certify-wrap">
          <div className="certify-code">
            <p className="tit">인증코드</p>
            <div className="code">{state.certCode}</div> 
            {/* { window.M.navigator.device('ios') ? (
              <div className="code">{state.certCode}</div> 
              ):(
              <div className="code">{strCode.substring(0,4) + "-"+ strCode.substring(5,8)+ "-"+ strCode.substring(9,13)}</div> 
              )
            } */}
          </div>
          <h3 className="h3-tit line">인증서 가져오기 방법</h3>
          <ol className="olist1 mt10">
            <li>
              <span>1</span>[PC] [PC] 홈페이지 접속
            </li>
            <li>
              <span>2</span>[PC] ‘마이페이지 &gt; 인증서 관리 &gt; 인증서 내보내기’ 클릭
            </li>
            <li>
              <span>3</span>[PC] 복사할 인증서를 선택하고 인증서 암호 입력
            </li>
            <li>
              <span>4</span>[PC] 인증코드 입력 후 ‘인증서 보내기‘ 클릭
            </li>
            <li>
              <span>5</span>[모바일 기기] 하단의 확인 버튼 클릭
            </li>
          </ol>
          <p className="desc-text mt20">＊PC에서 사용하던 암호를 그대로 설정하여 사용해도 됩니다.</p>
          {!state.crtfctSuccess ? (
            <div className="btn-block center mt140">
              <a href="#" className="btn-primary lg w200" onClick={getCrtfctConfirm}>
                확인
              </a>
            </div>
          ) : (
            <></>
          )}
          {state.crtfctSuccess ? (
            <div className="certify-wrap">
              <div className="certify-password">
                <p className="tit">인증서 비밀번호를 입력하세요.</p>
                <input
                  type="password"
                  className="form-keyword"
                  title={'비밀번호 입력'}
                  id="password"
                  name="password"
                  value={state.password}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="btn-block center mt140">
                <a href="#" className="btn-primary lg w200" onClick={getCrtfctDownLoad}>
                  인증서가져오기
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* <!-- //contents --> */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctStepMobile01)
